import { useContainerTabsContext } from './ContainerTabsContext'
import type { ContainerTabPanelProps } from './types'
import styles from './ContainerTabs.module.css'

/**
 * Painel de conteúdo de uma aba dentro de container.
 * Só é visível quando a aba correspondente está ativa.
 */
export function ContainerTabPanel({
  children,
  value,
  className,
  keepMounted = false,
}: ContainerTabPanelProps) {
  const { activeTab, tabsId } = useContainerTabsContext()
  
  const isActive = activeTab === value
  const tabId = `${tabsId}-tab-${value}`
  const panelId = `${tabsId}-panel-${value}`
  
  // Se keepMounted for false, não renderiza o conteúdo quando oculto
  if (!keepMounted && !isActive) {
    return null
  }
  
  return (
    <div
      id={panelId}
      role="tabpanel"
      aria-labelledby={tabId}
      tabIndex={0}
      hidden={!isActive}
      className={[
        styles.containerTabPanel,
        isActive && styles.containerTabPanelActive,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  )
}
